import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from "react-router-dom";
import DefaultLayout from '../layouts/DefaultLayout';
import Customer from '../interfaces/Customer';
import { fetchWithAuth } from '../services/Fetch';
import { toast } from 'react-toastify';

const CustomersForm: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const [customer, setCustomer] = useState<Customer>({ title: '', description: '' } as Customer);
    const navigate = useNavigate();
    const [loading, setLoading] = useState<boolean>(true);

    const fetchCustomer = async () => {
        if (id) {
            try {
                const response = await fetchWithAuth('/customers/' + id);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                setCustomer(data as Customer);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching customer:', error);
                setLoading(false);

            }
        } else {
            setLoading(false);
        }

    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement>) => {
        const { name, value } = event.target;
        setCustomer(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        const response = await fetchWithAuth(
            '/customers' + (id ? "/" + id : ""),
            {
                method: id ? "PUT" : "POST",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(customer)
            }
        );
        if (!response.ok) {
            throw new Error('Network response was not ok');
        } else {
            toast.success("Client ajouté")
            navigate("/customers");
        }
    };


    useEffect(() => {
        fetchCustomer();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (loading) {
        return <DefaultLayout><h1>Chargement...</h1></DefaultLayout>;
    }

    return (
        <DefaultLayout>
            <h1>Création d&apos;un client</h1>
            <form onSubmit={handleSubmit}>
                <div className="mb-3">
                    <label htmlFor="title" className="form-label required-field">Titre</label>
                    <input
                        type="text"
                        className="form-control"
                        id="title"
                        name="title"
                        value={customer.title}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="mb-3">
                    <label htmlFor="title" className="form-label">Description</label>
                    <textarea
                        className="form-control"
                        id="description"
                        name="description"
                        value={customer.description ?? ""}
                        onChange={handleChange}
                    />
                </div>
                <div className="row">
                    <div className="col-6"><button type="submit" className="btn btn-primary">{id ? "Modifier le client" : "Créer le client"}</button></div>
                    <div className="col-6 d-flex justify-content-end"><Link to="/customers" className="btn btn-danger">Annuler</Link></div>
                </div>
            </form>
        </DefaultLayout>
    );
}

export default CustomersForm;